import { Utils } from 'react-awesome-query-builder';

export const initialTree = {
  type: 'group',
  id: Utils.uuid(),
  children1: {
    [Utils.uuid()]: {
      type: 'rule',
      properties: {
        field: null,
        operator: null,
        value: [],
        valueSrc: [],
        operatorOptions: null,
      },
    },
  },
  properties: {
    conjunction: 'AND',
  },
};

export function fromQueryBuilderToTree(serializedRules) {
  const rules = typeof serializedRules === 'string' ? JSON.parse(serializedRules) : serializedRules;
  const tree = {
    type: 'group',
    id: Utils.uuid(),
    children1: {},
    properties: {
      conjunction: rules.condition,
    },
  };

  rules.rules.forEach((rule) => {
    tree.children1[rule.id] = {
      type: 'rule',
      properties: {
        field: rule.fieldName || rule.field,
        operator: rule.operator,
        valueType: rule.values.map((value) => value.type),
        value: rule.values.map((value) => value.value),
        valueSrc: ['value'],
      },
    };
  });

  return tree;
}
